import useScrollReset from '../hooks/useScrollReset';

const ScrollReset = () : any => {
  useScrollReset();

  return null;
};

export default ScrollReset;
